/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable no-unused-vars */
/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-inline-styles */

import React from 'react';
import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';

import RenderIf from '@components/global/RenderIf';
import { IMAGE_URL } from './constant';

const Header = ({ isSpreading = false, isVn = false }) => {
  const vn = isVn;
  return (
    <View style={styles.header} fixed>
      <RenderIf condition={isSpreading}>
        <View style={styles.headerSpreading}>
          <Text style={{ fontWeight: 700 }}>PROFORMA INVOICE</Text>
        </View>
      </RenderIf>
      <View style={styles.headerAddress}>
        <Image src={IMAGE_URL} style={styles.headerImage} />
        <View style={styles.headerText}>
          {vn ? (
            <>
              <Text style={{ fontWeight: 700, fontSize: 10, marginBottom: 5 }}>
                Social Bella Vietnam Company Limited
              </Text>
              <Text>Floor 5, No 53 – 55 – 57 Pho Duc Chinh Street</Text>
              <Text>Ward Nguyen Thai Binh, District 1</Text>
              <Text>TP Hồ Chí Minh, Vietnam</Text>
            </>
          ) : (
            <>
              <Text style={{ fontWeight: 700, fontSize: 10, marginBottom: 5 }}>
                PT Semesta Distribusi Indonesia
              </Text>
              <Text>
                St. Moritz Office Tower, Unit 0502, Puri Indah CBD Blok U1
              </Text>
              <Text>
                Jalan Puri Indah Raya, Desa/Kelurahan Kembangan Selatan
              </Text>
              <Text>
                Kec. Kembangan, Kota Adm. Jakarta Barat, Provinsi DKI Jakarta,
                11610
              </Text>
              <Text>Indonesia</Text>
            </>
          )}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    borderBottom: '1px solid #bbb',
    paddingBottom: 10,
    marginBottom: 25,
  },
  headerAddress: {
    paddingHorizontal: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  headerText: {
    fontSize: 7,
    textAlign: 'right',
    flex: 1,
    lineHeight: 1.3,
  },
  headerImage: {
    width: 100,
    height: 48,
    objectFit: 'contain',
  },

  headerSpreading: {
    width: '100%',
    textAlign: 'center',
    borderTop: '1px solid #bbb',
    borderBottom: '1px solid #bbb',
    paddingVertical: 10,
  },
});

export default Header;
